import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useFilterCompaniesTagStyles = makeStyles(() =>
  createStyles({
    groupChip: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      width: '100%',
      '& > div': {
        marginBottom: 40,
        marginRight: 16
      }
    }
  })
)
